import { GRID_COLS, GRID_ROWS, PLOT_COUNT, PLOT_SPACING } from './constants';

export interface GridCell {
  col: number;
  row: number;
}

export function plotCell(plotId: number): GridCell {
  return { col: plotId % GRID_COLS, row: Math.floor(plotId / GRID_COLS) };
}

export function plotIdAt(col: number, row: number): number | null {
  if (col < 0 || row < 0 || col >= GRID_COLS || row >= GRID_ROWS) return null;
  return row * GRID_COLS + col;
}

export function isValidPlotId(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value < PLOT_COUNT;
}

/** World-space centre (x, z) of a plot; the field is centred on the origin. */
export function plotPosition(plotId: number): { x: number; z: number } {
  const { col, row } = plotCell(plotId);
  return {
    x: (col - (GRID_COLS - 1) / 2) * PLOT_SPACING,
    z: (row - (GRID_ROWS - 1) / 2) * PLOT_SPACING,
  };
}

/** Orthogonally adjacent plot ids. */
export function neighbors(plotId: number): number[] {
  const { col, row } = plotCell(plotId);
  const out: number[] = [];
  for (const [dc, dr] of [
    [1, 0],
    [-1, 0],
    [0, 1],
    [0, -1],
  ] as const) {
    const id = plotIdAt(col + dc, row + dr);
    if (id !== null) out.push(id);
  }
  return out;
}

/** Half-extent of the whole field in world units (used for layout and collisions). */
export const FIELD_HALF_EXTENT = (Math.max(GRID_COLS, GRID_ROWS) * PLOT_SPACING) / 2;
